import { TableFieldModel } from '@/model/TableList'
import { priceWithoutRate } from '@/utils/index'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'no',
    fieldName: '编号'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'customerCompany',
    fieldName: '客户公司'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'customerNo',
    fieldName: '客户单号'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'price',
    width: 120,
    fieldName: '总费用(含税)',
    isMoney: true,
    textAlign: 'right'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'price1',
    width: 120,
    fieldName: '总费用(未税)',
    isMoney: true,
    textAlign: 'right',
    convert: context => {
      const { rowData } = context
      const { price } = rowData
      if (!price) {
        return ''
      }
      const { taxRate } = rowData
      return priceWithoutRate(price, true, taxRate)
    }
  }, {
    componentType: 'el-rate',
    componentName: '输入框',
    fieldKey: 'taxRate',
    fieldName: '税率',
    formatType: 'percent'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'title',
    fieldName: '所属公司'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'originatorName',
    fieldName: '制单人'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'changeStatus',
    fieldName: '修改状态'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'status',
    fieldName: '状态'
  }
]
